import axios from 'axios';

export default {
    updateProductStatus(productId, statusCode) {
        return axios.post('/status/updateProductStatus/', {
            productId: productId,
            statuscode: statusCode,
        });
    },
    fetchAllStatuses() {
        return axios.post('/status/fetchAllStatuses/');
    },
    updateProductStatusBatch(statuscode, productNrs) {
        return axios.post('/status/updateProductStatusBatch/', {
            statuscode,
            productNrs,
        });
    },
};
